import React from 'react';

const Intro = () => {
    return (
        <div className="container">
            <div className="flex flex-col md:flex-row   mx-auto py-4 mt-5 gap-8">
                {/* Left content section */}
                <div className="md:w-1/2 py-4 flex flex-col justify-center ">
                    <h1 className="text-2xl md:text-4xl font-bold text-blue-900 mb-6">
                        Vos procédures simplifiées, votre avenir assuré !
                    </h1>

                    <p className="text-base mb-4">
                        Chez MesProcédures.fr, notre mission est claire : rendre vos démarches administratives{' '}
                        <span className="font-semibold text-blue-900"> simples, rapides et accessibles à tous.</span>.
                    </p>

                    <p className="text-base mb-4">
                        Nous vous accompagnons pas à pas dans toutes les étapes {' '}
                        <span className="font-semibold text-blue-900"> pour l’obtention d’un titre de séjour
                        ou de la nationalité française.</span> <br/> Grâce à des informations claires et actualisées, vous
                        avez une vision précise des exigences légales et des conditions à remplir.

                    </p>
                    <p className="text-base mb-4">
                        Nous vous mettons en relation avec les meilleurs avocats spécialisés en droit des étrangers,
                        rigoureusement sélectionnés pour leur expertise et leur professionnalisme. Ils vous accompagnent
                        avec sérieux, efficacité et bienveillance, du début à la fin de votre procédure.
                    </p>

                    {/* Services section */}
                    <div className="grid grid-cols-2 md:grid-cols-2 gap-4 my-6">
                        <div className="flex items-center">
                            <div className="our-red-bg rounded-full p-2 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none"
                                     viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"/>
                                </svg>
                            </div>
                            <span className="font-semibold text-blue-900">Avocats spécialistes</span>
                        </div>

                        <div className="flex items-center">
                            <div className="our-red-bg rounded-full p-2 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none"
                                     viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M13 10V3L4 14h7v7l9-11h-7z"/>
                                </svg>
                            </div>
                            <span className="font-semibold text-blue-900">Service accéléré</span>
                        </div>

                        <div className="flex items-center">
                            <div className="our-red-bg rounded-full p-2 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none"
                                     viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M14 10h4.764a2 2 0 011.789 2.894l-3.5 7A2 2 0 0115.263 21h-4.017c-.163 0-.326-.02-.485-.06L7 20m7-10V5a2 2 0 00-2-2h-.095c-.5 0-.905.405-.905.905 0 .714-.211 1.412-.608 2.006L7 11v9m7-10h-2M7 20H5a2 2 0 01-2-2v-6a2 2 0 012-2h2.5"/>
                                </svg>
                            </div>
                            <span className="font-semibold text-blue-900">Confidentialité assurée</span>
                        </div>

                        <div className="flex items-center">
                            <div className="our-red-bg rounded-full p-2 mr-3">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-white" fill="none"
                                     viewBox="0 0 24 24" stroke="currentColor">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                          d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                                </svg>
                            </div>
                            <span className="font-semibold text-blue-900">Prix concurrentiel</span>
                        </div>
                    </div>

                    {/* Call to action button */}
                    <div className="mt-4">
                        <a
                            href="/contact"
                            className="banner-btn text-white px-8 py-3 button-red rounded-full font-medium transition-all hover:shadow-lg france-flag-button-animation"
                        >
                            Lancez vos procédures
                        </a>

                    </div>
                </div>

                {/* Right image section */}
                <div className="md:w-1/2 py-4 mt-6 md:mt-0 ">
                    <div className="relative h-full w-full">
                        <img
                            src={"/assets/img/theme/aboutus.jpg"}
                            /*
                                                        src="https://demarchefrancaise.fr/wp-content/uploads/2025/01/image-50-931x1024.jpg"
                            */
                            alt="Professionnels de mesProcédures"
                            className="w-full h-full object-cover rounded-lg shadow-lg"
                        />
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Intro;